module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SuperHeavyItalic.167deb2.eot";